/* Finery - Product template helpers (v1)
 * - Color swatches swap main image via JSON map (media alt -> url)
 * - Simple carousels (prev/next) for model images + print examples
 */

function safeJsonParse(text, fallback = {}) {
  try {
    return JSON.parse(text);
  } catch {
    return fallback;
  }
}

function normalizeKey(str) {
  return (str || '').trim();
}

function findBestUrl(map, label) {
  const keyExact = normalizeKey(label);
  if (!keyExact) return null;

  // Direct hits first
  const direct =
    map[keyExact] ||
    map[keyExact.toLowerCase()] ||
    map[keyExact.toUpperCase()] ||
    null;
  if (direct) return direct;

  // Fuzzy match: media alt like "Red / Front", "Color: Red", etc.
  const needle = keyExact.toLowerCase();
  for (const [k, v] of Object.entries(map)) {
    if (!k) continue;
    const hay = String(k).toLowerCase();
    if (hay === needle) return v;
    if (hay.includes(needle)) return v;
    if (needle.includes(hay)) return v;
  }
  return null;
}

function initColorSwatches() {
  document.querySelectorAll('[data-finery-product-hero]').forEach(hero => {
    const mapId = hero.getAttribute('data-color-map-id');
    const mapEl = mapId ? document.getElementById(mapId) : null;
    const map = mapEl ? safeJsonParse(mapEl.textContent, {}) : {};

    const mainImg = hero.querySelector('[data-finery-main-image]');
    const selectedEl = hero.querySelector('[data-finery-selected-color]');
    const buttons = hero.querySelectorAll('.finery-color-swatch');

    if (!buttons.length) return;

    const select = (btn) => {
      const label = btn.getAttribute('data-color-label') || '';
      const url = findBestUrl(map, label);

      buttons.forEach(b => b.classList.toggle('is-selected', b === btn));
      if (selectedEl) selectedEl.textContent = label;
      if (mainImg && url) mainImg.src = url;
    };

    // Default: select first swatch
    select(buttons[0]);

    buttons.forEach(btn => {
      btn.addEventListener('click', () => select(btn));
    });
  });
}

function initCarousels() {
  document.querySelectorAll('[data-finery-carousel]').forEach(root => {
    const slides = Array.from(root.querySelectorAll('[data-finery-slide]'));
    const prev = root.querySelector('[data-finery-prev]');
    const next = root.querySelector('[data-finery-next]');
    if (!slides.length) return;

    let idx = 0;
    const show = (i) => {
      idx = (i + slides.length) % slides.length;
      slides.forEach((s, si) => {
        s.toggleAttribute('hidden', si !== idx);
      });
    };

    show(0);
    prev?.addEventListener('click', () => show(idx - 1));
    next?.addEventListener('click', () => show(idx + 1));
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initColorSwatches();
  initCarousels();
});


